import RereservationCompletePageV2 from "@/public/components/features/rereservation_complete/RereservationCompletePageV2"

const RereservationCompleteV2 = () => {
	return <RereservationCompletePageV2 />
}

export default RereservationCompleteV2
